
















































































import Vue from "vue";
import {
  required,
  requiredIf,
  integer,
  minValue
} from "vuelidate/lib/validators";

import { MigrateExportForm } from "../forms/MigrateExportForm";
import { Shop } from "@/features/shop/models/Shop";

export default Vue.extend({
  validations: {
    migrateExportForm: {
      shop: { required },
      amountPerFile: {
        required: requiredIf(function(this: any) {
          return this.migrateExportForm.useMultiPart;
        }),
        integer,
        minValue: minValue(1)
      }
    }
  },
  data() {
    const shops: Shop[] = [];
    const migrateExportForm: MigrateExportForm = { useMultiPart: false };
    const isLoading = false;
    const migrateData: any[] = [];
    const migrateMultiPartData: any[] = [];

    return {
      shops,
      migrateExportForm,
      isLoading,
      migrateData,
      migrateMultiPartData
    };
  },
  computed: {
    shopOptions() {
      return (this as any).shops;
    },
    hasMultipleDownload() {
      return (this as any).migrateMultiPartData.length > 0;
    },
    shopError() {
      return (this as any).$v.migrateExportForm.shop.$error
        ? "ร้าน is required"
        : "";
    },
    amountPerFileError() {
      return (this as any).$v.migrateExportForm.amountPerFile.$error
        ? "จำนวนต่อไฟล์ is required or invalid"
        : "";
    },
    csvFileName() {
      if ((this as any).migrateExportForm.shop) {
        return `Customers (${(this as any).migrateExportForm.shop.name}).csv`;
      }

      return "";
    }
  },
  async created() {
    await Promise.all([this.getShops()]);
  },
  methods: {
    async exportData() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      await this.migrateCustomers();
    },
    async exportCleanData() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      await this.migrateCleanCustomers();
    },
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async migrateCustomers() {
      this.isLoading = true;

      try {
        const {
          data
        } = await (this as any).$dep.migrateUseCase.migrateCustomers(
          this.migrateExportForm
        );
        this.migrateData = data;

        if (this.migrateExportForm.useMultiPart) {
          this.migrateMultiPartData = [];
          while (this.migrateData.length > 0) {
            this.migrateMultiPartData.push(
              this.migrateData.splice(0, this.migrateExportForm.amountPerFile!)
            );
          }
        } else {
          setTimeout(() => {
            (this as any).$refs.loadCsv.generate();
          }, 100);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async migrateCleanCustomers() {
      this.isLoading = true;

      try {
        const {
          data
        } = await (this as any).$dep.migrateUseCase.migrateCleanCustomers(
          this.migrateExportForm
        );
        this.migrateData = data;

        if (this.migrateExportForm.useMultiPart) {
          this.migrateMultiPartData = [];
          while (this.migrateData.length > 0) {
            this.migrateMultiPartData.push(
              this.migrateData.splice(0, this.migrateExportForm.amountPerFile!)
            );
          }
        } else {
          setTimeout(() => {
            (this as any).$refs.loadCsv.generate();
          }, 100);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    csvFileNamePart(part: number) {
      const names = this.csvFileName.split(".");
      names[names.length - 2] += `_part${part}`;

      return names.join(".");
    },
    clear() {
      this.$v.$reset();
      this.migrateExportForm = { useMultiPart: false };
      this.isLoading = false;
      this.migrateData = [];
      this.migrateMultiPartData = [];
    }
  }
});
